@if (loaderService.loading()) {
<div class="loader-overlay" style="z-index: 999999 !important;">
    <div class="loader-container">
        <div class="spinner">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
        <p>Loading...</p>
    </div>
</div>
}